import { HStack, Text } from '@chakra-ui/react';
import { Tooltip } from '@components/ui/tooltip';
import { memo } from 'react';

type Props = {
  label: string;
  isTechnical?: boolean;
  textStyle?: 'sm' | 'md' | 'screenStd';
};

function TargetId({ label, isTechnical = false, textStyle = 'md' }: Readonly<Props>) {
  if (!isTechnical) {
    return (
      <Tooltip content={label} openDelay={0.5}>
        <Text
          textStyle={textStyle}
          lineClamp={3}
          cursor="default"
          wordBreak="break-all"
          fontWeight="medium"
          paddingY={0.25}
          paddingX={0.5}
          backgroundColor="neutral.black"
        >
          {label}
        </Text>
      </Tooltip>
    );
  }
  return (
    <Tooltip content={label} openDelay={0.5}>
      <HStack backgroundColor="neutral.500" gap={0}>
        <Text textStyle={textStyle} fontWeight="medium" paddingX={0.5}>
          ?
        </Text>
        <Text
          textStyle={textStyle}
          fontWeight="medium"
          cursor="default"
          paddingX={0.5}
          marginRight={0.25}
          marginY={0.25}
          wordBreak="break-all"
          lineClamp={3}
          backgroundColor="neutral.black"
        >
          {label}
        </Text>
      </HStack>
    </Tooltip>
  );
}

export default memo(TargetId);
